module.exports = __webpack_public_path__ + "images/fa-get-a-physical-copy-of-your-certificate.jpg";